import { trackPromise } from 'react-promise-tracker';
import { create } from 'zustand';
import { getNotificationStyle } from '../common/notification';
import { IManifestChargeFilter } from '../components/FilterComponent/ManifestChargeFilterComponent';
import { ICustomerComplaintFilter, IDailyActivityFilter, IDeliverySLRReportFilter, IFilter, IFuelFilterParams, IVehicleTrackingReportFilter } from '../model/CommonModel';
import {
    DownloadBookingReportService,
    DownloadCashCollectionReportService,
    DownloadComplaintKpiReportService,
    DownloadComplaintReportService,
    DownloadCustomerInfoReportService,
    DownloadCustomerReportService,
    DownloadDailyActivityService,
    DownloadDeliverySLRDetailsService,
    DownloadDeliverySLRReportService,
    DownloadDeliverySheetReportService,
    DownloadEmployeeReportService,
    DownloadExemptionReportService,
    DownloadFFDBookingReportService,
    DownloadFODCODReportService,
    DownloadFinanceManifestReportService,
    DownloadFinanceManifestWithVehiclesReportService,
    DownloadFuelReportService,
    DownloadIRSManifestApprovalReportService,
    DownloadIRSShipmentReportService,
    DownloadLocateShipmentReportService,
    DownloadManifestChargeReportService,
    DownloadMarkenClientReportService,
    DownloadMarkenKPIReportService,
    DownloadMarkenReportService,
    DownloadMissPickUpReportService,
    DownloadNotDeliveryReportService,
    DownloadNotManifestedReportService,
    DownloadOperationReportService,
    DownloadPerformanceScanReportService,
    DownloadPfnReportService,
    DownloadPodAvailabilityReportService,
    DownloadPodBarcodeReportService,
    DownloadRTOReportService, DownloadTripPlanReportService,
    DownloadTripplanWaybillReportService,
    DownloadVehicleReportService,
    DownloadVehicleTrackingReportService,
    DownloadWaybillsNotDeliveredReportService,
    DownloadWaybillsNotInvoicedReportService,
    DownloadWbWiseFleetDetaisReportService,
    EmailManifestReportService,
    EmailManifestReportV2Service
} from '../services/report-service';
import { TWO_HUNDRED_SUCCESS_CODE, downloadBlob } from '../utils/app-common';
import { IReportState } from './../model/ReportModel';
import { responseData } from './common';
import { IManifestApprovalFilter } from '../components/FilterComponent/IRSManifestApprovalReport';
import { ICodFodFilter } from '../components/FilterComponent/FodCodReportFilterComponent';


const ReportStore = create<IReportState>(((set: any) => ({
    DownloadBookingReportAction: async (data: IFilter) => {
        const response = await DownloadBookingReportService(data);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            const { fileName, file } = responseData(response?.data);
            downloadBlob(file, `${fileName}.xlsx`, `application/xlsx`)
        }
        else {
            getNotificationStyle(response);
        }
    },
    DownloadOperationReportAction: async (data: IFilter) => {
        const response = await DownloadOperationReportService(data);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            const { fileName, file } = responseData(response?.data);
            downloadBlob(file, `${fileName}.xlsx`, `application/xlsx`)
        }
        else {
            getNotificationStyle(response);
        }

    },
    DownloadEmployeeReportAction: async (data: IFilter) => {
        const response = await DownloadEmployeeReportService(data);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            const { fileName, file } = responseData(response?.data);
            downloadBlob(file, `${fileName}.xlsx`, `application/xlsx`)
        }
        else {
            getNotificationStyle(response);
        }
    },
    DownloadNotDeliveryReportAction: async (data: IFilter) => {
        const response = await DownloadNotDeliveryReportService(data);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            const { fileName, file } = responseData(response?.data);
            downloadBlob(file, `${fileName}.xlsx`, `application/xlsx`)
        }
        else {
            getNotificationStyle(response);
        }
    },
    DownloadRTOReportAction: async (data: IFilter) => {
        const response = await DownloadRTOReportService(data);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            const { fileName, file } = responseData(response?.data);
            downloadBlob(file, `${fileName}.xlsx`, `application/xlsx`)
        }
        else {
            getNotificationStyle(response);
        }
    },
    DownloadTripPlanReportAction: async (data: IFilter) => {
        const response = await DownloadTripPlanReportService(data);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            const { fileName, file } = responseData(response?.data);
            downloadBlob(file, `${fileName}.xlsx`, `application/xlsx`)
        }
        else {
            getNotificationStyle(response);
        }
    },
    DownloadVehicleReportAction: async (data: IFilter) => {
        const response = await DownloadVehicleReportService(data);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            const { fileName, file } = responseData(response?.data);
            downloadBlob(file, `${fileName}.xlsx`, `application/xlsx`)
        }
        else {
            getNotificationStyle(response);
        }
    },
    DownloadFinanceManifestReportAction: async (data: IFilter) => {
        const response = await DownloadFinanceManifestReportService(data);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            const { fileName, file } = responseData(response?.data);
            downloadBlob(file, `${fileName}.xlsx`, `application/xlsx`)
        }
        else {
            getNotificationStyle(response);
        }
    },
    DownloadNotManifestedReportAction: async (data: IFilter) => {
        const response = await DownloadNotManifestedReportService(data);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            const { fileName, file } = responseData(response?.data);
            downloadBlob(file, `${fileName}.xlsx`, `application/xlsx`)
        }
        else {
            getNotificationStyle(response);
        }
    },
    DownloadManifestChargeReportAction: async (data: IManifestChargeFilter) => {
        const response = await DownloadManifestChargeReportService(data);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            const { fileName, file } = responseData(response?.data);
            downloadBlob(file, `${fileName}.xlsx`, `application/xlsx`)
        }
        else {
            getNotificationStyle(response);
        }
    },
    EmailManifestReportAction: async () => {
        const response = await EmailManifestReportV2Service();
        getNotificationStyle(response);
    },
    DownloadTripplanWaybillReportAction: async (data: IFilter) => {
        const response = await DownloadTripplanWaybillReportService(data);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            const { fileName, file } = responseData(response?.data);
            downloadBlob(file, `${fileName}.xlsx`, `application/xlsx`)
        }
        else {
            getNotificationStyle(response);
        }
    },
    DownloadCustomerReportAction: async (data: IFilter) => {
        const response = await DownloadCustomerReportService(data);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            const { fileName, file } = responseData(response?.data);
            downloadBlob(file, `${fileName}.xlsx`, `application/xlsx`)
        }
        else {
            getNotificationStyle(response);
        }
    },
    DownloadDeliverySheetReportAction: async (data: IFilter) => {
        const response = await DownloadDeliverySheetReportService(data);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            const { fileName, file } = responseData(response?.data);
            downloadBlob(file, `${fileName}.xlsx`, `application/xlsx`)
        }
        else {
            getNotificationStyle(response);
        }
    },
    DownloadLocateShipmentReportAction: async (data: IFilter) => {
        const response = await DownloadLocateShipmentReportService(data);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            const { fileName, file } = responseData(response?.data);
            downloadBlob(file, `${fileName}.xlsx`, `application/xlsx`)
        }
        else {
            getNotificationStyle(response);
        }
    },

    DownloadCashCollectionReportAction: async (data: IFilter) => {
        const response = await DownloadCashCollectionReportService(data);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            const { fileName, file } = responseData(response?.data);
            downloadBlob(file, `${fileName}.xlsx`, `application/xlsx`)
        }
        else {
            getNotificationStyle(response);
        }
    },
    DownloadWbWiseFleetDetaisReportAction: async (data: IFilter) => {
        const response = await DownloadWbWiseFleetDetaisReportService(data);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            const { fileName, file } = responseData(response?.data);
            downloadBlob(file, `${fileName}.xlsx`, `application/xlsx`)
        }
        else {
            getNotificationStyle(response);
        }
    },
    DownloadPodAvailabilityReportAction: async (data: IFilter) => {
        const response = await DownloadPodAvailabilityReportService(data);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            const { fileName, file } = responseData(response?.data);
            downloadBlob(file, `${fileName}.xlsx`, `application/xlsx`)
        }
        else {
            getNotificationStyle(response);
        }
    },
    DownloadExemptionReportAction: async (data: IFilter) => {
        const response = await DownloadExemptionReportService(data);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            const { fileName, file } = responseData(response?.data);
            downloadBlob(file, `${fileName}.xlsx`, `application/xlsx`)
        }
        else {
            getNotificationStyle(response);
        }
    },

    DownloadPfnReportAction: async (data: IFilter) => {
        const response = await DownloadPfnReportService(data);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            const { fileName, file } = responseData(response?.data);
            downloadBlob(file, `${fileName}.xlsx`, `application/xlsx`)
        }
        else {
            getNotificationStyle(response);
        }
    },
    DownloadCustomerInfoReportAction: async (data: IFilter) => {
        const response = await DownloadCustomerInfoReportService(data);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            const { fileName, file } = responseData(response?.data);
            downloadBlob(file, `${fileName}.xlsx`, `application/xlsx`)
        }
        else {
            getNotificationStyle(response);
        }
    },
    DownloadMarkenReportAction: async (data: IFilter) => {
        const response = await DownloadMarkenReportService(data);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            const { fileName, file } = responseData(response?.data);
            downloadBlob(file, `${fileName}.xlsx`, `application/xlsx`)
        }
        else {
            getNotificationStyle(response);
        }
    },
    DownloadDailyActivityReportAction: async (data: IDailyActivityFilter) => {
        const response = await DownloadDailyActivityService(data);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            const { fileName, file } = responseData(response?.data);
            downloadBlob(file, `${fileName}.xlsx`, `application/xlsx`)
        }
        else {
            getNotificationStyle(response);
        }
    },
    DownloadMarkenClientReportAction: async (data: IFilter) => {
        const response = await DownloadMarkenClientReportService(data);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            const { fileName, file } = responseData(response?.data);
            downloadBlob(file, `${fileName}.xlsx`, `application/xlsx`)
        }
        else {
            getNotificationStyle(response);
        }
    },
    DownloadMarkenKPIReportAction: async (data: IFilter) => {
        const response = await DownloadMarkenKPIReportService(data);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            const { fileName, file } = responseData(response?.data);
            downloadBlob(file, `${fileName}.xlsx`, `application/xlsx`)
        }
        else {
            getNotificationStyle(response);
        }
    },
    DownloadWaybillsNotDeliveredReportAction: async (data: IDailyActivityFilter) => {
        const response = await DownloadWaybillsNotDeliveredReportService(data);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            const { fileName, file } = responseData(response?.data);
            downloadBlob(file, `${fileName}.xlsx`, `application/xlsx`)
        }
        else {
            getNotificationStyle(response);
        }
    },
    DownloadWaybillsNotInvoicedReportAction: async (data: IDailyActivityFilter) => {
        const response = await DownloadWaybillsNotInvoicedReportService(data);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            const { fileName, file } = responseData(response?.data);
            downloadBlob(file, `${fileName}.xlsx`, `application/xlsx`)
        }
        else {
            getNotificationStyle(response);
        }
    },
    DownloadComplaintReportAction: async (data: ICustomerComplaintFilter) => {
        const response = await DownloadComplaintReportService(data);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            const { fileName, file } = responseData(response?.data);
            downloadBlob(file, `${fileName}.xlsx`, `application/xlsx`)
        }
        else {
            getNotificationStyle(response);
        }
    },
    DownloadComplaintKpiReportAction: async (data: ICustomerComplaintFilter) => {
        const response = await DownloadComplaintKpiReportService(data);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            const { fileName, file } = responseData(response?.data);
            downloadBlob(file, `${fileName}.xlsx`, `application/xlsx`)
        }
        else {
            getNotificationStyle(response);
        }
    },

    DownloadDeliverySLRReportAction: async (data: IDeliverySLRReportFilter) => {
        const response = await DownloadDeliverySLRReportService(data);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            const { fileName, file } = responseData(response?.data);
            downloadBlob(file, `${fileName}.xlsx`, `application/xlsx`)
        }
        else {
            getNotificationStyle(response);
        }
    },

    DownloadDeliverySLRDetailsReportAction: async (data: IDeliverySLRReportFilter) => {
        const response = await DownloadDeliverySLRDetailsService(data);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            const { fileName, file } = responseData(response?.data);
            downloadBlob(file, `${fileName}.xlsx`, `application/xlsx`)
        }
        else {
            getNotificationStyle(response);
        }
    },

    DownloadMissPickUpReportAction: async (data: IDeliverySLRReportFilter) => {
        const response = await DownloadMissPickUpReportService(data);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            const { fileName, file } = responseData(response?.data);
            trackPromise(downloadBlob(file, `${fileName}.xlsx`, `application/xlsx`), 'miss-pickup-report-area');
        }
        else {
            getNotificationStyle(response);
        }
    },

    DownloadPerformanceScanReportAction: async (data: IFilter) => {
        const response = await DownloadPerformanceScanReportService(data);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            const { fileName, file } = responseData(response?.data);
            downloadBlob(file, `${fileName}.xlsx`, `application/xlsx`)
        }
        else {
            getNotificationStyle(response);
        }
    },

    DownloadVehicleTrackingReportAction: async (data: IVehicleTrackingReportFilter) => {
        const response = await DownloadVehicleTrackingReportService(data);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            const { fileName, file } = responseData(response?.data);
            downloadBlob(file, `${fileName}.xlsx`, `application/xlsx`)
        }
        else {
            getNotificationStyle(response);
        }
    },

    DownloadIRSShipmentReportAction: async (data: IFilter) => {
        const response = await DownloadIRSShipmentReportService(data);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            const { fileName, file } = responseData(response?.data);
            downloadBlob(file, `${fileName}.xlsx`, `application/xlsx`)
        }
        else {
            getNotificationStyle(response);
        }
    },
    DownloadIRSManifestApprovalReportAction: async (data: IManifestApprovalFilter) => {
        const response = await DownloadIRSManifestApprovalReportService(data);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            const { fileName, file } = responseData(response?.data);
            downloadBlob(file, `${fileName}.xlsx`, `application/xlsx`)
        }
        else {
            getNotificationStyle(response);
        }
    },

    DownloadPodBarcodeReportAction: async (data: IFilter) => {
        const response = await DownloadPodBarcodeReportService(data);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            const { fileName, file } = responseData(response?.data);
            downloadBlob(file, `${fileName}.xlsx`, `application/xlsx`)
        }
        else {
            getNotificationStyle(response);
        }
    },

    DownloadFuelReportAction: async (data: IFuelFilterParams) => {
        const response = await DownloadFuelReportService(data);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            const { fileName, file } = responseData(response?.data);
            downloadBlob(file, `${fileName}.xlsx`, `application/xlsx`);
        }
        else {
            getNotificationStyle(response);
        }
    },
    DownloadFinanceManifestWithVehiclesReportAction: async (data: IFilter) => {
    const response = await DownloadFinanceManifestWithVehiclesReportService(data);
    if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
      const { fileName, file } = responseData(response?.data);
      downloadBlob(file, `${fileName}.xlsx`, `application/xlsx`);
    }
  },
      DownloadFFDBookingReportAction: async (data) => {
        const response = await DownloadFFDBookingReportService(data);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            const { fileName, file } = response?.data?.data;
            trackPromise(downloadBlob(file, `${fileName}.xlsx`, `application/xlsx`), 'ffd-booking-report-area');
        }
        else {
            getNotificationStyle(response);
        }
    },

    DownloadFODCODReportAction: async (data: ICodFodFilter) => {
        const response = await DownloadFODCODReportService(data);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            const { fileName, file } = responseData(response?.data);
            downloadBlob(file, `${fileName}.xlsx`, `application/xlsx`)
        }
        else {
            getNotificationStyle(response);
        }
    },


})))

export const useReportStore = (ReportStore)